module.exports = __webpack_public_path__ + "media/images/404-img-1038ea78a88a6e9e6433b0ee4c345240.png";